import { Upload, Wand2, Download, ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    icon: Upload,
    title: "Upload Your Brief",
    text: "Send us your listing photos, brand assets, and what you need — a room tour, drone footage, or a promo clip. Two minutes of work.",
  },
  {
    n: "02",
    icon: Wand2,
    title: "We Produce Your Content",
    text: "360° room tour, drone flight, or promo clip — produced in 48 hours and tailored to your company's brand. A human editor reviews every frame.",
  },
  {
    n: "03",
    icon: Download,
    title: "Download & Publish",
    text: "Get ready-to-post files for MLS, Instagram, YouTube, and your website. Full commercial rights, forever.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="bg-hero-cream py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        chapter="02 — Process"
        title="From Brief to Published in 3 Steps"
        sub="360° room tours, drone flights, and promo clips — no production headaches, no six-week timelines."
      />

      <div className="relative grid gap-8 md:grid-cols-3">
        {STEPS.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.15}>
            <div
              className="group relative h-full rounded-md border-2 border-hero-black/10 bg-white p-8 shadow-md transition-all duration-300 ease-out hover:-translate-y-2 hover:border-hero-black hover:shadow-xl"
              data-testid={`how-it-works-card-${i + 1}`}
            >
              <span className="font-display text-7xl font-bold text-outline-blue" aria-hidden="true">
                {step.n}
              </span>
              <div className="mt-6 inline-flex rounded-md bg-hero-blue p-3 text-white transition-colors duration-300 group-hover:bg-hero-gold group-hover:text-hero-black">
                <step.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-hero-black sm:text-3xl">
                {step.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-hero-black/70">{step.text}</p>
              {i < STEPS.length - 1 && (
                <ArrowRight className="absolute -right-7 top-1/2 hidden h-6 w-6 -translate-y-1/2 text-hero-black/30 md:block" aria-hidden="true" />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
